// src/app/core/interceptor/cache.interceptor.ts
import {HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from "../../../environments/environment";

export const cacheInterceptor: HttpInterceptorFn = (req: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<any>> => {
    const yii2ApiBaseUrl = environment.apiUrl;

    if (req.url.startsWith(yii2ApiBaseUrl)) {
        // Clone the request to add the new headers.
        const clonedRequest = req.clone({
            headers: req.headers
                .set('Cache-Control', 'no-cache')
                .set('Pragma', 'no-cache')
        });
        return next(clonedRequest);
    } else {
        return next(req);
    }
};
